module.exports = __webpack_public_path__ + "img/icn-sub-t2.32bb281c.png";